import { render, staticRenderFns } from "./OpenButton.vue?vue&type=template&id=7cbc2afa"
import script from "./OpenButton.vue?vue&type=script&lang=js"
export * from "./OpenButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cbc2afa')) {
      api.createRecord('7cbc2afa', component.options)
    } else {
      api.reload('7cbc2afa', component.options)
    }
    module.hot.accept("./OpenButton.vue?vue&type=template&id=7cbc2afa", function () {
      api.rerender('7cbc2afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/MultiSelectionBadge/OpenButton.vue"
export default component.exports